// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatHistory_wrapper__Vo2xj","title":"ChatHistory_title__ugNvn","content":"ChatHistory_content__7ncZk"};